//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	var App = angular.module('pphhApp');
	
	App.service("validateActionController", [ "$mdDialog", "$window", ValidateActionController ]);

	function ValidateActionController($mdDialog, $window) {
		this.performAction = performAction;
		

		function performAction(scope) {
			var confirm = 
				$mdDialog.confirm()
				.clickOutsideToClose(true).title(UIMessages.dialog.confirm.title)
				.htmlContent(UIMessages.visor.check)
				.ok(UIMessages.dialog.confirm.ok)
				.cancel(UIMessages.dialog.confirm.cancel);
			
			$mdDialog.show(confirm).then(function() {
				$window.open(_contextPath + "/pphhNav/executeValidations");
			});
		}
	}

})();